/* eslint-disable no-unused-vars */
import pinzApiService from "services/pinzApiService";
import { Button } from "components/Common/button";
import { saveUserData2 } from "services/firebase";
import { useUserData } from "hooks/useUserData";
import { useEffect, useState } from "react";
import Text from "components/Common/Text";
import { useForm } from "react-hook-form";
import Venmo from "assets/venmo-blue.svg";
import { useAuth } from "hooks/useAuth";

// eslint-disable-next-line react/prop-types
function VenmoForm({ setOpen }) {
  const { user } = useAuth();
  const { venmoAccount } = useUserData(user) ?? "";

  const {
    handleSubmit,
    formState: { errors },
    register,
    reset,
  } = useForm({});

  const [laading, setLoading] = useState(false);

  useEffect(() => {
    reset({
      venmoAccount,
    });
  }, [reset, venmoAccount]);

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const res = await pinzApiService.updateVenmoAcoount({
        phoneNumber: user?.phone,
        venmoAccount: data.venmoAccount,
      });

      if (res) {
        saveUserData2({
          uid: user.uid,
          patch: { venmoAccount: data.venmoAccount },
        });
        setOpen();
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 32, display: "flex", flexDirection: "column" }}>
      <img
        src={Venmo}
        alt="venmo"
        style={{ height: 26, alignSelf: "center", marginBottom: 28 }}
      />

      <Text as="P3" style={{ color: "#5C6363" }}>
        What a game! To get paid via Venmo, please enter your Venmo Account name
        below. Your account won&apos;t be used for this match payout, but
        we&apos;ll save it for your next match.
      </Text>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div>
          <Text as="P3" bold mt={10} style={{ color: "#232C2E" }}>
            Your Venmo account
          </Text>
          <div style={{ position: "relative", width: "100%", zIndex: 0 }}>
            <input
              {...register("venmoAccount", {
                required: true,
              })}
              className="venmoField"
              placeholder="username or email"
              style={{
                height: 52,
                width: "100%",
                minWidth: 329,
                borderRadius: 16,
                marginTop: 8,
                paddingLeft: 34,
              }}
            />
            <Text
              as="P1"
              style={{
                position: "absolute",
                left: 16,
                top: 23,
                color: "black",
              }}
            >
              @
            </Text>
          </div>
          <Text as="C2" bold mt={10} style={{ color: "#8E9191" }}>
            All payment inquiries will be sent to this user.
          </Text>
          {errors.venmoAccount && (
            <Text as="C2" bold mt={10} style={{ color: "#8E9191" }}>
              {errors.venmoAccount.message}
            </Text>
          )}
          <Text
            as="P3"
            ta="center"
            mt={16}
            style={{ color: "#232C2E", padding: "0px 16px" }}
          >
            Please make sure your Venmo Account information is correct.
          </Text>
          <Text as="P3" ta="center" style={{ color: "#E24955", padding: 16 }}>
            This action cannot be undone
          </Text>
          <Button
            title="Confirm Venmo Account"
            style={{ width: "100%" }}
            onPress={handleSubmit(onSubmit)}
            type="submit"
            blocked={laading}
          />
        </div>
      </form>
    </div>
  );
}

export { VenmoForm };
